/**
 * Resource danh mục mã dự phòng
 * ntduong2 24/4/2023
 */
export default {
  Title: 'Mã dự phòng',
  Dictionary: 'Danh mục',
  FolderPath: '/ Mục lục ngân sách / Mã dự phòng',
  BudgetProvideCode: 'Mã dự phòng *',
  Description: 'Diễn giải',
};
